import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Componentes de la página
import Navbar from "../components/navbar";
import About from "../components/about";
import Features from "../components/features";
import GetInTuch from "../components/getInTuch";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import Beneficios from "../components/Beneficios";
import Ecosistema from "../components/Ecosistema";
import WordWide from "../components/WordWide";
import VideoBackground from "../components/VideoBackground";
import HubspotScript from "../components/husbspotScript";
import CarouselTestimonios from "../components/CarouselTestimonios";
import CertificacionesCarousel from "../components/CertificacionesCarousel";
import PalabrasCarousel from "../components/PalabrasCarousel";
import Cookie from "../components/Cookie";
import Seo from "../components/Seo";
import CarouselHero from "../components/CarouselHero";

// Estado global (Zustand)
import useStore from "../store/useStore";

export default function Index() {
  const location = useLocation();

  // Extraemos del store los datos de la home y SEO
  const {
    home,
    getHomeHero,
    seoHomes,
    fetchSeoHomes,
    fetchHomeBloqus,
    fetchHomes,
    fetchHomeBloque1s,
    fetchHomeBloque2s,
    homeBloqus,
    homes,
    homeBloque1s,
    homeBloque2s,
    fetchHomeCarousel,
    slides
  } = useStore();

  // Obtenemos datos de SEO (meta tags)
  const seo = seoHomes?.[0]?.seo;

  // API base URL para imágenes y videos
  const urlApi = process.env.REACT_APP_STRAPI_URL;

  // Cargamos datos de home y SEO cuando se monta el componente
  useEffect(() => {
    getHomeHero();
    fetchSeoHomes();
    fetchHomeBloqus();
    fetchHomes();
    fetchHomeBloque1s();
    fetchHomeBloque2s();
    fetchHomeCarousel();
  }, [
    getHomeHero,
    fetchSeoHomes,
    fetchHomeBloqus,
    fetchHomes,
    fetchHomeBloque1s,
    fetchHomeBloque2s,
    fetchHomeCarousel
  ]);

  // Si hay un hash en la URL (por ejemplo #section-two), hacemos scroll a esa sección
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);

  return (
    <>
      {/* SEO dinámico para motores de búsqueda y redes sociales */}
      <Seo
        metaTitle={seo?.meta_title}
        metaDescription={seo?.meta_descripcion}
        metaImage={seo?.metaimage?.url}
        metaKeywords={seo?.meta_keywords}
        canonicalURL={seo?.canonical_url}
      />
      {/* Encabezado y navegación */}
      <header>
        <Navbar />
      </header>
      {/* Contenido principal del sitio */}
      <main className="relative overflow-hidden leading-[1.3] bg-sidom-light dark:bg-sidom-blue">
        {/* Hero principal con video y CTA */}
        {home?.length !== 0 && (
          <section data-aos="fade-up" aria-label="Hero principal">
            {home.map((item) => (
              <VideoBackground
                key={item.id || item.titulo}
                video={`${urlApi}${item.video[0]?.url}`}
                titulo1={item.titulo}
                titulo2={item.text}
                textbutton="SOLICITAR DEMO"
                link="/contact"
                logo={`${urlApi}${
                  item.img?.formats?.thumbnail?.url ||
                  item.img?.url ||
                  "/placeholder-logo.png"
                }`}
              />
            ))}
          </section>
        )}

        {home?.length === 0 && (
          <section data-aos="fade-up">
            <CarouselHero data={slides?.data} />
          </section>
        )}

        {/* Secciones del sitio con animaciones AOS y etiquetas ARIA */}
        <section aria-label="Sobre nosotros">
          <About data={homeBloque1s?.data} />
        </section>

        <section aria-label="Testimonios de clientes">
          <PalabrasCarousel />
        </section>

        <section
          id="Global-Trade"
          data-aos="fade-up"
          data-aos-delay="300"
          aria-label="Características"
        >
          <Features data={homeBloque2s?.data} />
        </section>

        <section
          data-aos="fade-up"
          data-aos-delay="300"
          aria-label="Testimonios"
        >
          <CarouselTestimonios />
        </section>

        <section
          data-aos="fade-up"
          data-aos-delay="300"
          aria-label="Presencia mundial"
        >
          <WordWide data={homeBloqus?.data} />
        </section>

        <section
          data-aos="fade-up"
          data-aos-delay="300"
          aria-label="Beneficios"
        >
          <Beneficios data={homes?.data} />
        </section>

        <section aria-label="Certificaciones">
          <CertificacionesCarousel />
        </section>

        <section aria-label="Ecosistema">
          <Ecosistema />
        </section>

        <section aria-label="Contacto">
          <GetInTuch />
        </section>
      </main>
      {/* Componentes adicionales */}
      <Cookie /> {/* Aviso de cookies */}
      <HubspotScript /> {/* Scripts de HubSpot */}
      {/* Pie de página */}
      <footer>
        <Footer />
      </footer>
      {/* Switch de tema / estilo */}
      <Switcher />
    </>
  );
}
